// extracted by mini-css-extract-plugin
module.exports = {"card":"MobilePaymentCard_card__1I2yf","title":"MobilePaymentCard_title__3-StY","cardContent":"MobilePaymentCard_cardContent__393P-","payBtn":"MobilePaymentCard_payBtn__es0Wx"};